import { render, staticRenderFns } from "./CorrespondenceSalutationCreateForm.vue?vue&type=template&id=751710d7"
import script from "./CorrespondenceSalutationCreateForm.vue?vue&type=script&lang=js"
export * from "./CorrespondenceSalutationCreateForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports